export const BoxStatus = Object.freeze({
  UNKNOWN: 0,
  WAITING: 1,
  STANDBY: 2,
  SELF_USE: 3,
  ELION: 4,
});

export const Status = Object.freeze({
  UNKNOWN: 0,
  ONLINE: 1,
  OFFLINE: 2,
});

export function getBoxStatusString(status, active_product) {
  switch (status) {
    case BoxStatus.UNKNOWN:
      return "Unknown";
    case BoxStatus.WAITING:
      return "Waiting";
    case BoxStatus.STANDBY:
      return "Standby";
    case BoxStatus.SELF_USE:
      return "Self-Use";
    case BoxStatus.ELION:
      return active_product;
    default:
      return "Unknown";
  }
}
